/* import {  } from '@/scripts/constants/test'; */
// import store from '@/scripts/store';
import { COUNTRIES } from '@/scripts/constants/countries';
import { usStates } from '@/scripts/constants/map';
import store from '@/scripts/store';

const findCountry = name => {
  const result = COUNTRIES.find(({ title }) => title === name);

  return result;
};

const findGame = (gameId, games = store.state.games) => {
  const result = games.find(({ id }) => id === gameId) || {};

  return result;
};

const findState = name => {
  const result = usStates.find(({ title }) => title === name);

  return result;
};

const getErrorCodes = e => {
  const { response = {} } = e;
  const { data = {} } = response;
  const { errors = [] } = data;
  const result = errors.map(({ code }) => code);

  return result;
};

const getDropdownValue = (val, arr) => {
  if (!arr || !arr.length) return null;

  const result = arr.find(({ value }) => value === val);

  return result;
};

const sortConnections = (a, b) => {
  if (a.status === 'connected' && b.status !== 'connected') return -1;
  if (a.status !== 'connected' && b.status === 'connected') return 1;

  const nameA = a.platformName.toUpperCase();
  const nameB = b.platformName.toUpperCase();

  if (nameA < nameB) return -1;
  if (nameA > nameB) return 1;

  return 0;
};

/*  */
export {
  findCountry,
  findState,
  getErrorCodes,
  findGame,
  getDropdownValue,
  sortConnections,
};
